var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col"},[_vm._t("header"),_c('div',{staticClass:"bg-white rounded-xs border-gray-300 p-32 border"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }